import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pages",
    class: _vm.theme
  }, [_c('div', {
    staticClass: "wallet page",
    class: _vm.isMobile && 'wap',
    style: {
      backgroundImage: `url(${require(`@images/${_vm.theme}/inset-bg.jpg`)})`
    }
  }, [_c('div', {
    staticClass: "wallet-main"
  }, [_vm._l(_vm.list, function (citem, index) {
    return citem.assets.length > 0 ? _c('div', {
      staticClass: "token-items"
    }, [_c('div', {
      staticClass: "token-title"
    }, [_c('img', {
      attrs: {
        "src": citem.icon
      }
    }), _vm._v(_vm._s(citem.name))]), _vm._l(citem.assets, function (item, index) {
      return _c('div', {
        staticClass: "token-item",
        on: {
          "click": function ($event) {
            return _vm.onDetail(citem, item);
          }
        }
      }, [_c('div', {
        staticClass: "balance-info"
      }, [_c('div', {
        staticClass: "balance__type"
      }, [_c('img', {
        attrs: {
          "src": item.icon
        }
      }), _c('div', {
        staticClass: "balance__name"
      }, [item.name.toUpperCase() == 'TAP' ? [_vm._v(" TAPS ")] : item.name.toUpperCase() == 'STARS' ? [_vm._v(" " + _vm._s(item.name) + " ")] : [_vm._v(" " + _vm._s(_vm._f("strToUpperCase")(item.name)) + " ")]], 2)]), _c('div', {
        staticClass: "balance__num"
      }, [item.name == 'usdt' ? [_vm._v(_vm._s(_vm._f("fmt_usdtPre")(item.balance)))] : [_vm._v(_vm._s(_vm._f("fmt_pre")(item.balance, 2)))]], 2)])]);
    })], 2) : _vm._e();
  }), _c('div', {
    staticClass: "wallet-banner",
    on: {
      "click": () => _vm.$router.push('/mpay')
    }
  }, [_c('div', {
    staticClass: "wallet-banner__bg"
  }, [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/mpayBanner.jpg'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "wallet-banner-main"
  }, [_c('div', {
    staticClass: "wallet-banner__text"
  }, [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/mpayBanner__title.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "wallet-banner-info"
  }, [_c('div', {
    staticClass: "wallet-banner-info__title"
  }, [_vm._v("Card application bonus:")]), _c('div', {
    staticClass: "wallet-banner-info-price"
  }, [_vm.mpayTaskInfo.taskInfo ? [_vm.mpayTaskInfo.taskInfo.reward ? _c('div', {
    staticClass: "wallet-banner-info-price-item"
  }, [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/TAPCOINS-small.png'),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm._f("fmt_pre")(_vm.mpayTaskInfo.taskInfo.reward)))]) : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward && (_vm.mpayTaskInfo.taskInfo.reward || _vm.mpayTaskInfo.taskInfo.reward_token) ? _c('div', {
    staticClass: "wallet-banner-info-price-item"
  }, [_vm._v("+")]) : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward_stock ? _c('div', {
    staticClass: "wallet-banner-info-price-item"
  }, [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/TAPSTOCK-small.png'),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm._f("fmt_pre")(_vm.mpayTaskInfo.taskInfo.reward_stock)))]) : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward_stock && _vm.mpayTaskInfo.taskInfo.reward_token ? _c('div', {
    staticClass: "wallet-banner-info-price-item"
  }, [_vm._v("+")]) : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward_token ? _c('div', {
    staticClass: "wallet-banner-info-price-item"
  }, [_vm.mpayTaskInfo.taskInfo.reward_token_symbol == 'USDT' ? _c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/USDT-small.png'),
      "alt": ""
    }
  }) : _vm.mpayTaskInfo.taskInfo.reward_token_symbol == 'TAP' ? _c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/TAP.png'),
      "alt": ""
    }
  }) : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward_token_symbol == 'USDT' ? [_vm._v(_vm._s(_vm._f("fmt_usdtPre")(_vm.mpayTaskInfo.taskInfo.reward_token)))] : _vm.mpayTaskInfo.taskInfo.reward_token_symbol == 'TAP' ? [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.mpayTaskInfo.taskInfo.reward_token)))] : _vm._e()], 2) : _vm._e()] : _vm._e()], 2)])])])], 2), _c('div', {
    staticClass: "mMenu"
  }, [_c('m-menu')], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };